import { html } from "lit-element";
import { DrawSVGBaseModule } from "../../ModuleBase/svg-base-module";

export class DrawDvHor2Module extends DrawSVGBaseModule {
	constructor(canvas) {
		super(canvas);

		this.name = "dv-hor-2";
		this.icon = svg_dv_hor_2;
	}
}

window.customElements.define("inspx-draw-dv-hor-2-module", DrawDvHor2Module);

const svg_dv_hor_2 = html`
<svg width="60" height="30" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
 <g>
  <title>Layer 1</title>
  <line id="svg_2" y2="30" x2="30" y1="30" x1="0" stroke="#444444" fill="none"/>
  <rect stroke="#444444" id="svg_1" height="30" width="59.62407" y="0" x="0" fill="#ffffff"/>
  <rect stroke="#000000" stroke-width="0" id="svg_5" height="29.28303" width="29.58336" y="0.5688" x="29.49134" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" fill="#aaa7a7"/>
  <text stroke="#000000" transform="rotate(-0.06877446174621582 28.367965698244337,15.276235580443814) matrix(1.8460991017711428,0,0,1.2207685708999634,-15.963852308870411,14.850047273377912) " xml:space="preserve" text-anchor="middle" font-family="Sans-serif" font-size="24" id="svg_4" y="8.6746" x="23.96421" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000">DV</text>
  <line y2="14.78384" x2="43.93414" y1="14.78384" x1="13.93414" stroke="#444444" fill="none" transform="rotate(90 28.934143066406254,14.783843994140627) " id="svg_6"/>
 </g>
</svg>`;
